import { Button } from "@mui/material"
import { useState } from "react"
import rock from "./images/rock-stock.jpg"
import paper from "./images/paper-stock.jpg"
import scissors from "./images/scissors-stock.jpg"

import "./rockPaperScissors.css"

const rps = [
  {
    name: "Rock",
    weakTo: "Paper",
    image: rock
  },
  {
    name: "Paper",
    weakTo: "Scissors",
    image: paper
  },
  {
    name: "Scissors",
    weakTo: "Rock",
    image: scissors
  }
]

export default function RockPaperScissors(props) {
  const [gameState, setGameState] = useState("SELECT");
  const [winRecord, setWinRecord] = useState(0);
  const [lossRecord, setLossRecord] = useState(0);
  const [drawRecord, setDrawRecord] = useState(0);
  const [aiSelectionName, setAiSelectionName] = useState("");
  const [playerSelectionName, setPlayerSelectionName] = useState("");
  const [resultText, setResultText] = useState("");
  const [timer, setTimer] = useState(3);
  const [confetti, setConfetti] = useState(false);
  const [tryAgain, setTryAgain] = useState(false);
  
  // let aiSelection;
  // let playerSelection;
  // let resultText;

  const selectObject = (element) => {
    const aiSelection = rps[Math.floor(Math.random() * rps.length)];
    const playerSelection = element;
    let result;

    if (playerSelection.name === aiSelection.name) {
      result = "Draw!";
    }

    if (playerSelection.weakTo === aiSelection.name) {
      result = "You Lose!"
    }

    if (aiSelection.weakTo === playerSelection.name) {
      result = "You Win!";
    }

    setResultText(result);
    setAiSelectionName(aiSelection.name);
    setPlayerSelectionName(playerSelection.name);
    // setGameState("RESULT");
    startTimer(result === "You Win!");
  }

  const getImageForName = (name) => {
    if (name === "Paper") {
      return paper;
    }

    if (name === "Scissors") {
      return scissors;
    }

    return rock;
  }

  const startTimer = (win) => {
    let t = 3;
    setTimer(t);
    setGameState("TIMER");
    const interval = setInterval(
      () => {
        console.log(timer)
        if (t > 1) {
          t--;
          setTimer(t);
        }else {
          setTimeout(() => {
            if (win) {
              setConfetti(true)
            }
            setTryAgain(true);
          }, 2200);
          // if (win) {
          // }
          setGameState("RESULT");
          clearInterval(interval);
        }
      }, 1000
    );
  }

  return (
    <div
      className="rps-container"
      id={confetti ? "win-background" : null}
    >
      {gameState === "SELECT" && (
        <h2
          className="make-selection-header"
        >
          Make Selection
        </h2>
      )}

      {gameState === "RESULT" && (
        <div
          className="results-container"
        >
          <h2
            id={resultText === "You Win!" ? "win-text" : 
              resultText === "You Lose!" ? "loss-text" : "draw-text"}
            className="result-text"
          >
            {resultText}
          </h2>
          <div
            className="results-inner-container"
          >
            <div className="player-result-text">
              <img 
                className="image"
                src={getImageForName(playerSelectionName)}
              />
              <p>
                You picked {playerSelectionName}
              </p>
            </div>

            <div className="opponent-result-text">
              <img 
                className="image"
                src={getImageForName(aiSelectionName)}
              />
              <p>
                I picked {aiSelectionName}
              </p>
            </div>
          </div>

          <Button variant="contained" className="result-text" onClick={() => {
            setGameState("SELECT")
            setConfetti(false);
            setTryAgain(false);
          }}>
            Try Again
          </Button>
        </div>
      )}

      <div
        className="select-container"
      >
        {gameState === "SELECT" && rps.map((element, i) => (
          <div
            className="select-button-container"
          >
            <img 
              src={element.image}
              className="image"
            />


            <Button 
              className="select-button"
              variant="contained" 
              key={element.name} 
              onClick={() => selectObject(element)}
              >
              {element.name}
            </Button>
          </div>
        ))}

      </div>
        {/* {tryAgain && (
          <Button variant="contained" className="result-text" onClick={() => {
            setGameState("SELECT")
            setConfetti(false);
            setTryAgain(false);
          }}>
            Try Again
          </Button>
        )} */}


      {gameState === "TIMER" && 
        <div>
          <h2>{timer}</h2>
        </div>
      }
    </div>
  )
}